import { ProductTypes } from './ProductTypes';

export const deviceTypes = [
  ProductTypes.TABLET,
  ProductTypes.PHONE,
  ProductTypes.MODEM,
  ProductTypes.MYKI,
  ProductTypes.DRIVEY,
  ProductTypes.YETTEL_HOME,
];
